const { createContext, useContext } = require("react");

const GuideContext = createContext({
    tryStartTour: async () => {},
    isTourEligible: async () => false
});

export const useGuideTools = () => useContext(GuideContext);

export const GuideContextProvider = GuideContext.Provider;